const mockProducts = [
  {
    id: 1,
    category: "Laptop",
    brand: "HP",
    model: "EliteBook 1030 G2 x360",
    price: 5400,
    availability: true,
    condition: "UK_USED",
    description: "Neat as new. Sim slot activated. Keyboard backlight. Face ID Recognition.",
    processor: "Intel Core i7 7th Gen 2.90GHz",
    ram: "16GB",
    storage: "256GB SSD",
    graphics: "8GB Intel UHD Graphics",
    display: "13.3\" Touchscreen x360",
    hasBacklight: true,
    hasFingerprint: false,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Silver",
    batteryLife: "Good",
    image: "https://image.coolblue.nl/max/394xauto/products/1407909",
    warranty: ""
  },
  {
    id: 2,
    category: "Laptop",
    brand: "HP",
    model: "EliteBook 840 G5",
    price: 3700,
    availability: true,
    condition: "UK_USED",
    description: "Face ID Recognition. Fingerprint Sensor. Type C port.",
    processor: "Intel Core i5 8th Gen 1.7GHz",
    ram: "8GB",
    storage: "256GB SSD",
    graphics: "Intel UHD Graphics",
    display: "14\"",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Silver",
    batteryLife: "",
    image: "https://images-cdn.ubuy.co.in/6340e2d5b6bc4f29b1332b3b-hp-elitebook-840-g5-14-34-fhd.jpg",
    warranty: ""
  },
  {
    id: 3,
    category: "Laptop",
    brand: "Apple",
    model: "MacBook Pro 2015",
    price: 3300,
    availability: true,
    condition: "UK_USED",
    description: "Early 2015. Neat as new. Strong Battery.",
    processor: "Intel Core i5",
    ram: "8GB",
    storage: "128GB SSD",
    graphics: "Intel Iris Graphics 6100 536MB",
    display: "13\"",
    hasBacklight: true,
    hasFingerprint: false,
    hasWebcam: true,
    hasFaceId: false,
    hasUsbC: false,
    color: "Silver",
    batteryLife: "Strong",
    image: "https://www.mystore.in/s/62ea2c599d1398fa16dbae0a/64589ce644da7bcb9a0d1fc6/pxl_20230421_130714911-640x640.jpg",
    warranty: ""
  },
  {
    id: 4,
    category: "Laptop",
    brand: "Dell",
    model: "Latitude 3190",
    price: 2700,
    availability: true,
    condition: "UK_USED",
    description: "Touchscreen x360. Win 11 Pro.",
    processor: "Intel Pentium Silver 8th Gen",
    ram: "8GB",
    storage: "128GB SSD",
    graphics: "UHD Graphics 605",
    display: "12\" Touchscreen",
    hasBacklight: false,
    hasFingerprint: false,
    hasWebcam: false,
    hasFaceId: false,
    hasUsbC: false,
    color: "Black",
    batteryLife: "Excellent",
    image: "https://lapshop07.com/wp-content/uploads/2024/10/IMG-20241020-WA0035.jpg",
    warranty: ""
  },
  {
    id: 5,
    category: "Laptop",
    brand: "Dell",
    model: "Precision 7530",
    price: 5600,
    availability: true,
    condition: "UK_USED",
    description: "Gaming & Graphics. 4GB Dedicated Graphics NVIDIA Quadro P2000.",
    processor: "Intel Xeon 8th Gen 2.7GHz",
    ram: "16GB",
    storage: "512GB SSD",
    graphics: "NVIDIA Quadro P2000 4GB",
    display: "15\"",
    hasBacklight: true,
    hasFingerprint: false,
    hasWebcam: true,
    hasFaceId: false,
    hasUsbC: true,
    color: "Black",
    batteryLife: "",
    image: "https://files.refurbed.com/pi/dell-precision-7530-i9-8950hk-1741074117.jpg?t=fitdesign&h=600&w=800",
    warranty: ""
  },
  {
    id: 6,
    category: "Laptop",
    brand: "Apple",
    model: "MacBook Pro 2018",
    price: 6700,
    availability: true,
    condition: "UK_USED",
    description: "macOS High Sierra. Touch Bar.",
    processor: "Intel Core i5 2.3GHz",
    ram: "16GB",
    storage: "500GB",
    graphics: "Intel Iris Plus Graphics",
    display: "13\"",
    hasBacklight: true,
    hasFingerprint: false,
    hasWebcam: true,
    hasFaceId: false,
    hasUsbC: true,
    color: "Space Gray",
    batteryLife: "",
    image: "https://www.cnet.com/a/img/resize/7dc0ce072e83064e3ecd1e13586dea707f272187/hub/2017/06/27/13484418-bfd9-41e2-8f2d-9b4afb072da8/apple-macbook-pro-15-inch-2017-14.jpg?auto=webp&width=768",
    warranty: ""
  },
  {
    id: 7,
    category: "Laptop",
    brand: "Dell",
    model: "XPS 13",
    price: 3800,
    availability: true,
    condition: "UK_USED",
    description: "7th Generation. Full HD screen. Excellent battery.",
    processor: "Intel Core i5 7th Gen 2.70GHz",
    ram: "8GB",
    storage: "256GB SSD",
    graphics: "Intel HD Graphics",
    display: "13\" FHD",
    hasBacklight: true,
    hasFingerprint: false,
    hasWebcam: true,
    hasFaceId: false,
    hasUsbC: true,
    color: "Silver",
    batteryLife: "Excellent",
    image: "https://dellstatic.luroconnect.com/media/catalog/product/cache/74ae05ef3745aec30d7f5a287debd7f5/x/s/xs9320nt-xnb-shot-5-1-sl.jpg",
    warranty: ""
  },
  {
    id: 8,
    category: "Laptop",
    brand: "HP",
    model: "Envy x360m",
    price: 5200,
    availability: true,
    condition: "UK_USED",
    description: "Convertible. Ryzen 5 with Radeon Vega mobile GFX. 2GB dedicated graphics.",
    processor: "AMD Ryzen 5 2500U",
    ram: "8GB",
    storage: "256GB SSD",
    graphics: "Radeon Vega 2GB",
    display: "14\" Touchscreen x360",
    hasBacklight: false,
    hasFingerprint: false,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Black",
    batteryLife: "Good",
    image: "https://m.media-amazon.com/images/I/51OIcC2oKoL._AC_UF894,1000_QL80_.jpg",
    warranty: ""
  },
  {
    id: 9,
    category: "Laptop",
    brand: "Dell",
    model: "Precision 5550",
    price: 6600,
    availability: true,
    condition: "UK_USED",
    description: "4GB Dedicated Graphics NVIDIA Quadro T1000. 10th Gen i7.",
    processor: "Intel Core i7 10th Gen 2.60GHz",
    ram: "16GB",
    storage: "512GB SSD",
    graphics: "NVIDIA Quadro T1000 4GB",
    display: "15.6\" FHD",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Silver",
    batteryLife: "Good",
    image: "https://images-cdn.ubuy.co.in/69390438557851ba1a08a063-dell-precision-5550-15-mobile.jpg",
    warranty: ""
  },
  {
    id: 10,
    category: "Phone",
    brand: "Apple",
    model: "iPhone 16 Pro Max",
    price: 16000,
    availability: true,
    condition: "NEW",
    description: "16 Series. 512GB. Desert Titanium.",
    processor: "A18 Pro",
    ram: "",
    storage: "512GB",
    graphics: "",
    display: "6.9\" Super Retina XDR",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Desert Titanium",
    batteryLife: "",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQInzI69QTfhKGZZJSTKjbTAdI4ZeJ5fhSBBw&s",
    warranty: "1 Year"
  },
  {
    id: 11,
    category: "Phone",
    brand: "Apple",
    model: "iPhone 16 Pro Max",
    price: 14700,
    availability: true,
    condition: "NEW",
    description: "16 Series. 256GB. SIM.",
    processor: "A18 Pro",
    ram: "",
    storage: "256GB",
    graphics: "",
    display: "6.9\" Super Retina XDR",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Natural Titanium",
    batteryLife: "",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQInzI69QTfhKGZZJSTKjbTAdI4ZeJ5fhSBBw&s",
    warranty: "1 Year"
  },
  {
    id: 12,
    category: "Phone",
    brand: "Apple",
    model: "iPhone 16",
    price: 10000,
    availability: true,
    condition: "NEW",
    description: "16 Series. 128GB.",
    processor: "A18",
    ram: "",
    storage: "128GB",
    graphics: "",
    display: "6.1\" Super Retina XDR",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Ultramarine",
    batteryLife: "",
    image: "https://www.apple.com/newsroom/images/2024/09/apple-introduces-iphone-16-and-iphone-16-plus/article/geo/Apple-iPhone-16-finish-lineup-geo-240909_big.jpg.large.jpg",
    warranty: "1 Year"
  },
  {
    id: 13,
    category: "Phone",
    brand: "Apple",
    model: "iPhone 15 Pro",
    price: 10000,
    availability: true,
    condition: "NEW",
    description: "15 Series. 128GB.",
    processor: "A17 Pro",
    ram: "",
    storage: "128GB",
    graphics: "",
    display: "6.1\" Super Retina XDR",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Titanium",
    batteryLife: "",
    image: "https://bestpricegh.com/cdn/shop/files/5-iphone-15-pro-max9.02.45AM_c337d019-d894-424d-8a5a-770df424981a.jpg?crop=center&height=600&v=1695910648&width=600",
    warranty: ""
  },
  {
    id: 14,
    category: "Phone",
    brand: "Apple",
    model: "iPhone 14 Pro Max",
    price: 9500,
    availability: true,
    condition: "NEW",
    description: "14 Series. 128GB. SIM.",
    processor: "A16 Bionic",
    ram: "",
    storage: "128GB",
    graphics: "",
    display: "6.7\" Super Retina XDR",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Deep Purple",
    batteryLife: "",
    image: "https://assets.mmsrg.com/isr/166325/c1/-/ASSET_MP_147119766?x=536&y=402&format=jpg&quality=80&sp=yes&strip=yes&trim&ex=536&ey=402&align=center&resizesource&unsharp=1.5x1+0.7+0.02&cox=0&coy=0&cdx=536&cdy=402",
    warranty: ""
  },
  {
    id: 15,
    category: "Phone",
    brand: "Apple",
    model: "iPhone 13",
    price: 4800,
    availability: true,
    condition: "NEW",
    description: "13 Series. 128GB.",
    processor: "A15 Bionic",
    ram: "",
    storage: "128GB",
    graphics: "",
    display: "6.1\" Super Retina XDR",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: true,
    hasUsbC: true,
    color: "Blue",
    batteryLife: "",
    image: "https://www.apple.com/newsroom/images/product/iphone/geo/Apple_iphone13_colors_geo_09142021_big.jpg.slideshow-large_2x.jpg",
    warranty: ""
  },
  {
    id: 16,
    category: "Smart Watch",
    brand: "Samsung",
    model: "Gear S2",
    price: 500,
    availability: true,
    condition: "USED",
    description: "Classic circular smartwatch with rotating bezel. Wireless Charging.",
    processor: "Exynos 3250",
    ram: "512MB",
    storage: "4GB",
    graphics: "",
    display: "1.2\" AMOLED",
    hasBacklight: false,
    hasFingerprint: false,
    hasWebcam: false,
    hasFaceId: false,
    hasUsbC: false,
    color: "Silver",
    batteryLife: "2-3 days",
    image: "https://image-us.samsung.com/SamsungUS/pim/migration/mobile/wearables/smartwatches/sm-r7200zwaxar/Pdpdefault-sm-r7200zwaxar-600x600-C1-052016.jpg?$default-400-jpg$?$bu-pdp-image-mobile-jpg$",
    warranty: ""
  },
  {
    id: 17,
    category: "Accessory",
    brand: "USAMS",
    model: "A04 TWS Earbuds",
    price: 100,
    availability: false,
    condition: "USED",
    description: "Compact - budget-friendly earbuds. BT 5.0.",
    processor: "",
    ram: "",
    storage: "",
    graphics: "",
    display: "",
    hasBacklight: false,
    hasFingerprint: false,
    hasWebcam: false,
    hasFaceId: false,
    hasUsbC: false,
    color: "Black",
    batteryLife: "28 hours",
    image: "https://img.myipadbox.com/upload/store/product_l/IP6D0802B.jpg",
    warranty: ""
  },
  {
    id: 18,
    category: "Laptop",
    brand: "Lenovo",
    model: "ThinkPad X1 Carbon Gen 7",
    price: 4400,
    availability: true,
    condition: "UK_USED",
    description: "Generic 8th Gen i7. Ultra-light.",
    processor: "Intel Core i7 8th Gen",
    ram: "16GB",
    storage: "256GB SSD",
    graphics: "Intel UHD 620",
    display: "14\" FHD",
    hasBacklight: true,
    hasFingerprint: true,
    hasWebcam: true,
    hasFaceId: false,
    hasUsbC: true,
    color: "Black",
    batteryLife: "Excellent",
    image: "https://i.pcmag.com/imagery/reviews/02z7CXr7oYqrcleufNp2rfb-2..v1569469942.jpg",
    warranty: ""
  },
  {
    id: 19,
    category: "Laptop",
    brand: "Dell",
    model: "Latitude 7490",
    price: 3600,
    availability: true,
    condition: "UK_USED",
    description: "Intel Core i5 8th Gen. 4 cores 8 processors. Fixed price.",
    processor: "Intel Core i5 8th Gen 1.9GHz",
    ram: "8GB",
    storage: "256GB SSD",
    graphics: "Intel UHD Graphics",
    display: "14\" FHD",
    hasBacklight: true,
    hasFingerprint: false,
    hasWebcam: true,
    hasFaceId: false,
    hasUsbC: true,
    color: "Black",
    batteryLife: "Excellent",
    image: "https://pcshoppe.in/wp-content/uploads/2022/10/Dell-Latitude-7490-2-1-scaled.jpg",
    warranty: "1 month"
  }
];

export default mockProducts;